// Simple wrapper around axios to add rate limit handling
import axios from 'axios';

// Add response interceptor to handle 429 globally if needed
const setupInterceptors = (api) => {
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      // If 429 (Too Many Requests), we can broadcast an event or handle specific cases
      if (error.response && error.response.status === 429) {
        console.warn("Rate limit exceeded:", error.response.data);
      }
      return Promise.reject(error);
    }
  );
};

export default setupInterceptors;
